import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ImpactMetrics from "@/components/ImpactMetrics";

const POINTS = [
  {
    h: "Practical IT training",
    p: "Programs focus on real-world enterprise scenarios ,  the workflows, decisions, and tooling consultants and teams actually face.",
  },
  {
    h: "Global learner base",
    p: "Learners join from across regions, time zones, and roles ,  from freshers to senior consultants and implementation partners.",
  },
  {
    h: "B2C + B2B experience",
    p: "We work with individual learners and corporate teams ,  and design programs that work for both audiences.",
  },
  {
    h: "Live + flexible formats",
    p: "Live instructor-led, self-paced, workshops, and corporate bootcamps ,  chosen to match your pace and goal.",
  },
  {
    h: "Pre-enrolment guidance",
    p: "Talk to a training advisor before you commit ,  so you pick the right track for your role and goal.",
  },
  {
    h: "Role-focused curriculum",
    p: "Curriculum is shaped around what consultants, support engineers, analysts, and leaders do day-to-day.",
  },
];

export default function WhyZaranTech() {
  return (
    <section id="why-zarantech" className="py-12 lg:py-12 bg-tint-cyan relative">
      <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <p className="font-mono-ui text-[11px] uppercase tracking-[0.22em] text-royal">
              04 · Why ZaranTech
            </p>
            <h2 className="font-display text-2xl md:text-3xl lg:text-[38px] font-bold text-ink mt-3 leading-[1.02] text-balance">
              Built for professionals.{" "}
              <span className="text-royal-deep">Trusted by teams.</span>
            </h2>
            <p className="mt-6 text-[15.5px] leading-relaxed text-ink-soft max-w-md">
              ZaranTech isn&apos;t a course catalog. It&apos;s a focused training partner for enterprise
              technologies ,  chosen by learners and companies who want practical, role-shaped
              learning, not generic content.
            </p>
            <div className="mt-7 flex gap-3">
              <Link
                to="/about-us"
                className="inline-flex items-center gap-2 rounded-md bg-royal-deep px-5 py-3 text-sm font-semibold text-white hover:bg-royal"
              >
                Read About Us <ArrowRight size={14} />
              </Link>
              <Link
                to="/courses"
                className="inline-flex items-center gap-2 rounded-md border border-line bg-white px-5 py-3 text-sm font-semibold text-ink hover:border-royal hover:text-royal"
              >
                Explore Courses
              </Link>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="columns-1 md:columns-2 gap-x-8 [column-fill:_balance]">
              {POINTS.map((p, i) => (
                <div
                  key={p.h}
                  className="break-inside-avoid mb-7"
                >
                  <div className="flex items-baseline gap-3">
                    <span className="font-mono-ui text-[11px] tracking-[0.22em] text-royal">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <h3 className="font-display text-lg font-bold text-ink">{p.h}</h3>
                  </div>
                  <p className="mt-2 text-[14.5px] leading-relaxed text-ink-soft">{p.p}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Impact metrics strip ,  real numbers */}
        <div className="mt-14">
          <ImpactMetrics surface="dark" />
        </div>
      </div>
    </section>
  );
}
